import { TabContext, TabList, TabPanel } from "@mui/lab"
import { Grid, Tab } from "@mui/material"
import { useCallback } from "react"
import { Localized } from "@fluent/react"
import { useSearchParams } from "react-router-dom"
import { CompanyRoleReponsibilities } from "./companyRoleReponsibilities/CompanyRoleReponsibilities"

type FormTabs = "companyRoleResponsibilities"

export const CompanyDictionaries = () => {
    const [params, setParams] = useSearchParams()
    const tab = params.get('tab') as FormTabs || 'companyRoleResponsibilities'
    const setTab = (tab: FormTabs) => {
        params.set('tab', tab)
        setParams(params, { replace: true })
    }

    const handleTabChange = useCallback((_, newTab) => {
        setTab(newTab)
    }, [])

    return (
        <>
            <Grid container spacing={2}>
                <Grid item xs={12}>
                    <TabContext value={tab}>
                        <TabList onChange={handleTabChange}>
                            <Tab
                                key={0}
                                value={"companyRoleResponsibilities"}
                                label={<Localized id="role-responsibilities">_Responsibility Dictionary</Localized>} />

                        </TabList>
                        <TabPanel value="companyRoleResponsibilities">
                            <CompanyRoleReponsibilities />
                        </TabPanel>
                    </TabContext>
                </Grid>
            </Grid>
        </>
    )
}
